import { useEffect, useRef, useState } from 'react';

import invariant from 'tiny-invariant';

import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

import { isL1ItemData } from '../dnd-data';

type useL1DragStateProps = { l1DragAndDropEnabled?: boolean };
export function useL1DragState({ l1DragAndDropEnabled = false }: useL1DragStateProps) {
	const groupDropIndicatorRef = useRef<HTMLDivElement | null>(null);
	const [dragState, setDragState] = useState<'idle' | 'is-over'>('idle');
	const [dragSource, setDragSource] = useState<string | null>(null);
	useEffect(() => {
		if (!l1DragAndDropEnabled) {
			return;
		}

		const l1GroupDropIndicator = groupDropIndicatorRef.current;
		invariant(l1GroupDropIndicator, 'l1GroupDropIndicatorRef should not be null');
		return dropTargetForElements({
			element: l1GroupDropIndicator,
			canDrop: ({ source }) => isL1ItemData(source.data),
			onDragStart({ source }) {
				setDragSource(source.data.menuItemId as string);
				setDragState('is-over');
			},
			onDragEnter() {
				setDragState('is-over');
			},
			onDragLeave() {
				setDragState('idle');
			},
			onDrop() {
				setDragSource(null);
				setDragState('idle');
			},
		});
	}, [l1DragAndDropEnabled]);

	return {
		groupDropIndicatorRef,
		dragState,
		dragSource,
	};
}
